/* Copyright (c)2023 Sky Co., LTD. All rights reserved. */
/// <summary>
/// 位置情報
/// ※メンバ変数の頭文字は小文字にしておくこと（キャメルケース）
/// </summary>

// 位置情報取得のレスポンス
export class EMMGetPositionListResponse {
	/// <summary>
	/// 次回があるかどうか
	/// </summary>
	isNext = false;

	/// <summary>
	/// 次回の時刻（Jsonコンバートで文字列になるため）
	/// </summary>
	nextTime = "";

	/// <summary>
	/// 位置情報要素のリスト
	/// </summary>
	positions = new Array<EMMPosition>();
}

// 位置情報要素
export class EMMPosition
{
	/// <summary>
	/// バージョン
	/// </summary>
	version = 1;

	/// <summary>
	/// 位置情報取得日時
	/// </summary>
	recordTime: Date = new Date();

	/// <summary>
	/// 緯度
	/// </summary>
	latitude = "";

	/// <summary>
	/// 経度
	/// </summary>
	longitude = "";

	/// <summary>
	/// ソース
	/// </summary>
	source = "";

	/// <summary>
	/// 位置情報の誤差
	/// </summary>
	accuracy = "";
	
	/// <summary>
	/// 収集タイプ 0: 定期収集による収集 1: 管理機からの要求による収集
	/// </summary>
	collecttype = 0;
}

/* Copyright (c)2023 Sky Co., LTD. All rights reserved. */
